module.exports = __webpack_public_path__ + "media/src/images/cc-2c97fa8882861299dfc55942dc3e8e29.png";